import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { IndexRoute } from '@americanexpress/one-app-router';

import { RenderModule } from 'holocron';
import AnalyticsWrapper from './components/AnalyticsWrapper';
import BasicError from './components/Errors/BasicError';
import ErrorLayout from './components/Errors/ErrorLayout';
import GlobalNavigationWrapper from './components/GlobalNavigationWrapper';
import LegacyOneXPWrapper from './components/LegacyOneXPWrapper';
import OneXpWrapper from './components/OneXpWrapper';
import setActiveLocale from './utils/setActiveLocale';
import constants from './utils/constants';

export const CanadaHub = (props) => <RenderModule moduleName="shop-canada-hub" props={props} />;
export const MexicoHub = (props) => <RenderModule moduleName="shop-mexico-hub" props={props} />;

const childRoutes = (store) => (
  <ModuleRoute onEnter={setActiveLocale(store)}>
    <ModuleRoute component={AnalyticsWrapper} shouldDisablePageView={true}>
      <ModuleRoute component={GlobalNavigationWrapper}>
        <ModuleRoute component={OneXpWrapper}>
          <ModuleRoute component={LegacyOneXPWrapper}>
            <ModuleRoute path="en-ca">
              <ModuleRoute path="credit-cards">
                <IndexRoute component={CanadaHub} moduleToCompose="shop-canada-hub" />
                <ModuleRoute path="compare-credit-cards" moduleName="shop-canada-compare-cards" />
              </ModuleRoute>
            </ModuleRoute>
            <ModuleRoute path="fr-ca">
              <ModuleRoute path="cartes-de-credit">
                <IndexRoute component={CanadaHub} moduleToCompose="shop-canada-hub" />
                <ModuleRoute path="comparer-les-cartes" moduleName="shop-canada-compare-cards" />
              </ModuleRoute>
            </ModuleRoute>
            <ModuleRoute path="es-mx">
              <ModuleRoute path="tarjetas-de-servicio">
                {constants?.UPLIFT_MX?.SERVICE_CARDS?.map((slug) => (
                  <ModuleRoute
                    key={slug}
                    path={slug}
                    moduleName="international-shop-product-details-mexico"
                  />
                ))}
              </ModuleRoute>
              <ModuleRoute path="tarjetas-de-credito">
                <IndexRoute component={MexicoHub} moduleToCompose="shop-mexico-hub" />
                <ModuleRoute path="comparar-tarjetas" moduleName="shop-mexico-compare-cards" />
              </ModuleRoute>
            </ModuleRoute>
            <ModuleRoute path="ja-jp">
              <ModuleRoute path="credit-cards">
                <ModuleRoute path="compare-cards" moduleName="shop-japan-compare-cards" />
              </ModuleRoute>
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>

    <ModuleRoute component={AnalyticsWrapper}>
      <ModuleRoute component={GlobalNavigationWrapper}>
        {/* INTL LEAD GEN */}
        <ModuleRoute lineOfBusiness="commercial">
          <ModuleRoute
            path="/:locale/business/form/:productName"
            moduleName="acq-shop-lead-generation"
          />
        </ModuleRoute>
        <ModuleRoute component={OneXpWrapper}>
          <ModuleRoute component={LegacyOneXPWrapper}>
            <ModuleRoute path="en-ca" moduleName="axp-international-shop-market-canada" />
            <ModuleRoute path="fr-ca" moduleName="axp-international-shop-market-canada" />
            <ModuleRoute path="es-mx" moduleName="axp-international-shop-market-mexico" />
            <ModuleRoute path="ja-jp" moduleName="axp-international-shop-market-japan" />
            <ModuleRoute path="en-au" moduleName="axp-international-shop-market-australia" />
            <ModuleRoute path="de-de" moduleName="axp-international-shop-market-germany" />
            <ModuleRoute path="en-gb" moduleName="axp-international-shop-market-uk" />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>

    <ModuleRoute component={AnalyticsWrapper}>
      <ModuleRoute component={GlobalNavigationWrapper}>
        <ModuleRoute lineOfBusiness="consumer">
          <ModuleRoute component={LegacyOneXPWrapper}>
            {/* UK */}
            <ModuleRoute path="en-gb">
              {/* International MCLP Pages */}
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="charge-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-GB"
              />
              {/* UK Routes */}
              {/* <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-uk-consumer-view-all-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-uk-consumer-view-all-cards"
                locale="en-GB"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-uk-consumer-card-details"
                locale="en-GB"
              />
              <ModuleRoute
                path="charge-cards/:cardslug"
                moduleName="axp-shop-ombrello-uk-consumer-card-details"
                locale="en-GB"
              /> */}
            </ModuleRoute>

            {/* New EN AU Routes */}
            <ModuleRoute path="en-au">
              <ModuleRoute
                path="credit-cards/:cardSlug/:cardFilter/:cardSubFilter"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-au-consumer-view-all-cards"
                locale="au_en"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-au-consumer-card-details"
                locale="au_en"
              />
              {/* International MCLP Pages */}
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="en-au"
              />
            </ModuleRoute>

            {/* MX Routes */}
            <ModuleRoute path="mx">
              <ModuleRoute
                path="tarjetas-de-credito/nuestras-tarjetas"
                moduleName="axp-shop-ombrello-mx-consumer-view-all-cards"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-credito/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-servicio/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
            </ModuleRoute>
            <ModuleRoute path="es-mx">
              <ModuleRoute
                path="tarjetas-de-credito/nuestras-tarjetas"
                moduleName="axp-shop-ombrello-mx-consumer-view-all-cards"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-credito/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
              <ModuleRoute
                path="tarjetas-de-servicio/:cardslug"
                moduleName="axp-shop-ombrello-mx-consumer-card-details"
                locale="es-mx"
              />
            </ModuleRoute>
            {/* JP Routes */}
            <ModuleRoute path="jp">
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-jp-consumer-card-details"
                locale="ja-jp"
              />
              {/* International MCLP Pages */}
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="ja-jp"
              />
            </ModuleRoute>
            <ModuleRoute path="ja-jp">
              <ModuleRoute
                path="credit-cards/compare/:pageName"
                moduleName="axp-international-shop-multi-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards/:cardFilter"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/all-cards"
                moduleName="axp-shop-ombrello-jp-consumer-view-all-cards"
                locale="ja-jp"
              />
              <ModuleRoute
                path="credit-cards/:cardslug"
                moduleName="axp-shop-ombrello-jp-consumer-card-details"
                locale="ja-jp"
              />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>

        {/* Commercial Routes */}
        <ModuleRoute lineOfBusiness="commercial">
          {/* Mexico Shop3 - Corp VAC */}
          <ModuleRoute path="es-mx">
            <ModuleRoute
              path="negocios/tarjetas-corporativas/"
              moduleName="axp-shop-international-commercial-view-all-cards"
              locale="es-MX"
              shopType="corporate"
              pageName="vac"
            />
            {/* Mexico Shop3 - Corp PDP */}
            <ModuleRoute
              path="negocios/tarjetas-corporativas/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="es-MX"
              shopType="corporate"
            />
            {/* Mexico - SBS PDP */}
            <ModuleRoute
              path="negocios/tarjetas/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="es-MX"
              shopType="business"
            />
          </ModuleRoute>
          {/* Canada EN VAC - SBS */}
          <ModuleRoute path="en-ca">
            <ModuleRoute
              path="business/credit-cards/"
              moduleName="axp-shop-international-commercial-view-all-cards"
              locale="en-ca"
              shopType="business"
              pageName="vac"
            />
            {/* Canada EN PDP - SBS */}
            <ModuleRoute
              path="business/credit-cards/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="en-ca"
              shopType="business"
            />
            {/* Canada EN VAC - Corp */}
            <ModuleRoute
              path="business/corporate-credit-cards/"
              moduleName="axp-shop-international-commercial-view-all-cards"
              locale="en-ca"
              shopType="corporate"
              pageName="vac"
            />
            {/* Canada EN PDP - Corp */}
            <ModuleRoute
              path="business/corporate-credit-cards/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="en-ca"
              shopType="corporate"
            />
          </ModuleRoute>

          {/* Canada FR VAC - SBS */}
          <ModuleRoute path="fr-ca">
            <ModuleRoute
              path="entreprise/cartes-de-credit/"
              moduleName="axp-shop-international-commercial-view-all-cards"
              locale="fr-ca"
              shopType="business"
              pageName="vac"
            />
            {/* Canada FR PDP - SBS */}
            <ModuleRoute
              path="entreprise/cartes-de-credit/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="fr-ca"
              shopType="business"
            />
            {/* Canada FR VAC - Corp */}
            <ModuleRoute
              path="entreprise/cartes-de-credit-pour-entreprises/"
              moduleName="axp-shop-international-commercial-view-all-cards"
              locale="fr-ca"
              shopType="corporate"
              pageName="vac"
            />
            {/* Canada FR PDP - Corp */}
            <ModuleRoute
              path="entreprise/cartes-de-credit-pour-entreprises/:pageName/"
              moduleName="axp-shop-international-commercial-card-details"
              locale="fr-ca"
              shopType="corporate"
            />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>

    {/* error routes */}
    <ModuleRoute component={AnalyticsWrapper}>
      <ModuleRoute key="error-page-navigation-wrapper" component={GlobalNavigationWrapper}>
        <ModuleRoute key="ErrorLayout" component={ErrorLayout}>
          <ModuleRoute code="500" component={BasicError} path="*/error" header="Load Error" />
          <ModuleRoute code="400" component={BasicError} path="*" header="Page Not Found" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>
);

export default childRoutes;
